import Sentry, { initializeSentry } from './tools/sentry'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Theme } from '@radix-ui/themes'
import { AuthProvider } from './features/auth/AuthProvider'
import { AnalyticsProvider } from './features/internal-analytics/AnalyticsProvider'

initializeSentry()

const queryClient = new QueryClient()

const Main = () => {
  return (
    <AnalyticsProvider>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
          <Theme className="flex" accentColor="mint" radius="medium" panelBackground="solid">
            <App queryClient={queryClient} />
          </Theme>
        </QueryClientProvider>
      </AuthProvider>
    </AnalyticsProvider>
  )
}

const container = document.getElementById('root')
const root = createRoot(container!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler()
})

root.render(
  <StrictMode>
    <Main />
  </StrictMode>
)
